<section class="container">
    <div
        *ngIf="data.headlineText || data.paragraph || data.link"
        class="content"
        [ngClass]="{ center: data.alignment === alignment.Center }"
    >
        <app-spot-headline *ngIf="data.headlineText as headlineText" [index]="data.spotIndex">
            {{ headlineText }}
        </app-spot-headline>
        <div class="kk-rte" *ngIf="data.paragraph" [innerHTML]="data.paragraph | safe: 'html'" appInterceptLinks></div>
        <div class="link-wrapper" *ngIf="data.link as mainlink">
            <app-link [link]="mainlink">
                <span class="kk-btn kk-btn_secondary link-btn">{{ mainlink.name }}</span>
            </app-link>
        </div>
    </div>
    <div class="row">
        <div
            *ngFor="let entrance of data.touchPointEntrances"
            class="col-12"
            [ngClass]="data.touchPointEntrances.length > 2 ? 'col-md-4' : 'col-md-6'"
        >
            <article class="entrance" [ngClass]="{ 'entrance_with-link': entrance.link }">
                <app-image
                    [image]="entrance.image"
                    [height]="458"
                    [width]="data.touchPointEntrances.length < 3 ? 703 : 458"
                    crop="crop"
                    *ngIf="entrance.image"
                ></app-image>
                <div class="entrance-content" *ngIf="entrance.headlineText || entrance.paragraph || entrance.link">
                    <h3 *ngIf="entrance.headlineText" class="entrance-headline">{{ entrance.headlineText }}</h3>
                    <div
                        class="kk-rte"
                        *ngIf="entrance.paragraph"
                        [innerHTML]="entrance.paragraph | safe: 'html'"
                        appInterceptLinks
                    ></div>
                    <div class="entrance-link-wrapper" *ngIf="entrance.link">
                        <app-arrow-link *ngIf="entrance.link as link" [link]="link" [arrowFirst]="true" [cover]="true">
                            {{ link.name }}
                        </app-arrow-link>
                    </div>
                </div>
            </article>
        </div>
    </div>
</section>
